import { render, staticRenderFns } from "./ChildPanel.vue?vue&type=template&id=85fcff52&scoped=true"
import script from "./ChildPanel.vue?vue&type=script&lang=js"
export * from "./ChildPanel.vue?vue&type=script&lang=js"
import style0 from "./ChildPanel.vue?vue&type=style&index=0&id=85fcff52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fcff52",
  null
  
)

export default component.exports